import { useEffect, useState } from 'react';
import logo from './imgs/logo.png';
import Document from './Document';
import './css/App.css';

const x = require('crypto-js');

function App() {
    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [password, setPassword] = useState("");
    const [loggedIn, setLoggedIn] = useState(false);
    const [loginError, setLoginError] = useState("");
    const [shouldResetErrorAnimation, setShouldResetErrorAnimation] = useState(false);

    useEffect(() => {
        if(loginError !== "" && shouldResetErrorAnimation)
        {
            setShouldResetErrorAnimation(false);
        }
    }, [shouldResetErrorAnimation, loginError]);

    const handleSubmit = event => {
        event.preventDefault();
        if(firstName === "" || lastName === "" || password === "")
        {
            setShouldResetErrorAnimation(true);
            setLoginError("Please fill out every field.");
            return;
        }
        const data = JSON.parse(x.AES.decrypt(process.env.REACT_APP_LOGINS, process.env.REACT_APP_SECRET).toString(x.enc.Utf8));
        console.log(data);
        if(data.hasOwnProperty(firstName.toLowerCase()) && data[firstName.toLowerCase()][0] === lastName.toLowerCase() && data[firstName.toLowerCase()][1] === password)
        {
            setLoginError("");
            setLoggedIn(true);
        }
        else
        {
            setShouldResetErrorAnimation(true);
            setLoginError("Incorrect login.");
        }
    };

    return (
        <div>
            <header className='burgundy-bg'>
                <a className='logo' href="https://www.nutleyschoolofmusic.com">
                    <img className='logo' src={logo} alt="logo"/>
                </a>
                <h2>Teacher Portal</h2>
            </header>

            {!loggedIn && (
                <section className='white-bg'>
                    <form onSubmit={handleSubmit}>
                        <div className='form-multi-input-container'>
                            <div className='form-input-container'>
                                <label htmlFor="fname">First Name</label>
                                <input type="text" 
                                    name="fname" id="fname" autoComplete="name"
                                    value={firstName} onChange={e => setFirstName(e.target.value)}/>
                            </div>
                            <div className='form-multi-input-spacer'></div>
                            <div className='form-input-container'>
                                <label htmlFor="lname">Last Name</label>
                                <input type="text" 
                                    name="lname" id="lname" autoComplete="name"
                                    value={lastName} onChange={e => setLastName(e.target.value)}/>
                            </div>
                        </div>
                        <div className='form-input-container'>
                            <label htmlFor="username">Password</label>
                            <input type="password" 
                                name="password" id="password"
                                value={password} onChange={e => setPassword(e.target.value)}/>
                        </div>
                        <input type="submit" value="Login"></input>
                        <p id="form-error-message" className={(loginError !== "" && !shouldResetErrorAnimation) ? "activated" : ""}>{loginError}</p>
                    </form>
                </section>
            )}

            {loggedIn && (
                <section className='white-bg'>
                    <div className='spacer'/>
                    <div className='documents-container'>
                        <Document title="Onboarding" filepath="/docs/OnBoarding-Teachers.pdf"/>
                        <Document title="PTO/Time Off" filepath="/docs/Sick-pay-PTO-Request.pdf"/>
                        <Document title="Employee Intake" filepath="/docs/Employee-Intake.pdf"/>
                    </div>
                </section>
            )}

        </div>
    );
}

export default App;
